/**
 * PDP：.ufc-pdp-zoom-trigger + data-ufc-pdp-zoom / data-ufc-pdp-zoom-alt
 * dialog 放在同一 .image-column 内（见 pdp-image-zoom-lightbox.liquid）
 */
(function () {
  /** 主产品图栏：main-product 的 .image-column，或餐品 PDP（product-right-meal-style）的 .prms2__left */
  function findZoomHost(el) {
    return el && el.closest && (el.closest('.image-column') || el.closest('.prms2__left'));
  }

  function openFromTrigger(trigger) {
    const url = trigger.getAttribute('data-ufc-pdp-zoom');
    if (!url) return;
    const col = findZoomHost(trigger);
    const dialog = col && col.querySelector('dialog.ufc-pdp-zoom-dialog');
    if (!dialog) return;
    const img = dialog.querySelector('.ufc-pdp-zoom-dialog__img');
    if (!img) return;
    img.src = url;
    img.alt = trigger.getAttribute('data-ufc-pdp-zoom-alt') || '';
    if (typeof dialog.showModal === 'function') {
      const scrollY = window.scrollY;
      const scrollX = window.scrollX;
      dialog.showModal();
      const restoreScroll = function () {
        window.scrollTo(scrollX, scrollY);
      };
      restoreScroll();
      requestAnimationFrame(restoreScroll);
      requestAnimationFrame(function () {
        requestAnimationFrame(restoreScroll);
      });
      queueMicrotask(function () {
        const closeBtn = dialog.querySelector('.ufc-pdp-zoom-dialog__close');
        if (closeBtn && typeof closeBtn.focus === 'function') {
          closeBtn.focus({ preventScroll: true });
        } else if (typeof dialog.focus === 'function') {
          dialog.focus({ preventScroll: true });
        }
        restoreScroll();
      });
    }
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.ufc-pdp-zoom-trigger');
    if (!trigger) return;
    e.preventDefault();
    openFromTrigger(trigger);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const trigger = e.target.closest('.ufc-pdp-zoom-trigger');
    if (!trigger) return;
    e.preventDefault();
    openFromTrigger(trigger);
  });

  document.addEventListener(
    'click',
    function (e) {
      const closeBtn = e.target.closest('.ufc-pdp-zoom-dialog__close');
      if (closeBtn) {
        const dialog = closeBtn.closest('dialog.ufc-pdp-zoom-dialog');
        if (dialog && typeof dialog.close === 'function') dialog.close();
        return;
      }
      const dialog = e.target.closest('dialog.ufc-pdp-zoom-dialog');
      if (dialog && e.target === dialog && typeof dialog.close === 'function') {
        dialog.close();
      }
    },
    true,
  );
})();
